// ------------------------------------
// Alertas de notificação
// ------------------------------------
const Toast = Swal.mixin({
  toast: true,
  position: 'bottom',
  showConfirmButton: false,
  timer: 5000,
});
const Alert = Swal.mixin({
  position: 'center',
  showConfirmButton: false,
  showCancelButton: true,
  cancelButtonText: 'Ok',
  customClass: {
    confirmButton: 'btn btn-secondary',
    cancelButton: 'btn btn-default',
    denyButton: 'btn btn-danger',
  },
  buttonsStyling: false,
});

// ------------------------------------
// Alertas de confirmaçao
// ------------------------------------
function showConfirm(opt) {
  let btnConfirmClass;
  switch (opt.type) {
    case 'warning':
      btnConfirmClass = 'btn btn-warning';
      break;
    case 'danger':
      btnConfirmClass = 'btn btn-danger';
      break;
    default:
      btnConfirmClass = 'btn btn-secondary';
      break;
  }
  Swal.fire({
    position: 'center',
    type: 'question',
    showConfirmButton: true,
    showCancelButton: true,
    reverseButtons: true,
    showCancelButton: true,
    showCloseButton: true,
    closeButtonHtml: '<i class="las la-times"></i>',
    closeButtonAriaLabel: 'Fechar janela',
    title: opt.title,
    text: opt.text,
    customClass: {
      confirmButton: btnConfirmClass,
      cancelButton: 'btn btn-default',
      denyButton: 'btn btn-danger',
    },
    buttonsStyling: false,
    confirmButtonText: opt.confirmButtonText,
    cancelButtonText: opt.cancelButtonText,
  }).then((result) => {
    if (result.value && typeof opt.callback === 'function') {
      opt.callback();
    } else if (typeof opt.cancel_cb === 'function') {
      opt.cancel_cb();
    }
  });
}

// Exibe o alerta de aviso da plataforma
$(function () {
  const prefixKey = 'viewed_alert_';

  $(window).on('load', function () {
    setTimeout(() => {
      let alertExibido = false;

      $('[data-notify-alert]').each(function () {
        if (alertExibido) return;

        const $alert = $(this);
        const alertId = $alert.data('notify-alert');
        const period = $alert.data('notify-period');

        if (shouldShowAlert(alertId, period)) {
          if ($alert.hasClass('alert-bar')) {
            $alert.addClass('open');
          } else if ($alert.hasClass('modal')) {
            $alert.modal('show');
          }
          alertExibido = true;
        }
      });
    }, 1000);
  });

  $('.alert-bar-close').on('click', function (ev) {
    ev.preventDefault();
    const $btn = $(this);
    const $alert = $btn.closest('[data-notify-alert]');
    const alertId = $alert.data('notify-alert');
    const period = $alert.data('notify-period');
    saveAlertView(alertId, period);
    $alert.removeClass('open');
  });

  $('.modal[data-notify-alert]').on('hidden.bs.modal', function () {
    const $modal = $(this);
    const alertId = $modal.data('notify-alert');
    const period = $modal.data('notify-period');
    saveAlertView(alertId, period);
  });

  function shouldShowAlert(id, period) {
    const storageKey = prefixKey + id;
    const value = localStorage.getItem(storageKey);
    if (!value) return true;

    if (period === 'one_time_day') {
      const today = new Date().toISOString().split('T')[0];
      return value !== today;
    }

    return false;
  }

  function saveAlertView(id, period) {
    const storageKey = prefixKey + id;
    if (period === 'one_time_day') {
      const today = new Date().toISOString().split('T')[0];
      localStorage.setItem(storageKey, today);
    } else {
      localStorage.setItem(storageKey, 'true');
    }
  }
});
